import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance} from "../../../utils/axios";
import { URLS } from "constants/api.constants";

export const bookmarkGet = createAsyncThunk('bookmark/bookmark', async(params, thunkApi) => {
    try{
        const response = await axiosInstance.get(`${URLS.BOOKMARK.GET_BOOKMARK}`,{ params: {page:1, ...params}});
        if(response.data?.success){
            return response.data;
        }else{
            return thunkApi.rejectWithValue(response.data?.message);
        }
    }catch(error){
        return thunkApi.rejectWithValue(error?.message);
    }
})

export const toggleBookmark = createAsyncThunk('post/toggleBookmark', async (post_id, thunkAPI) => {
    try {
        const response = await axiosInstance.post(URLS.BOOKMARK.TOGGLE_BOOKMARK, { post_id });
        if (response.data?.success) {
            return response.data;
        } else {
            return thunkAPI.rejectWithValue(response.data?.message || 'Failed to toggle bookmark');
        }
    } catch (error) {
        return thunkAPI.rejectWithValue(error?.message || 'An error occurred while toggling the bookmark');
    }
});
